// @ts-nocheck
import * as GraphQLSchema from '../graphql-types';

import * as Operations from './default-rates-query.graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetDefaultRatesQueryVariables = GraphQLSchema.Exact<{ [key: string]: never; }>;


export type GetDefaultRatesQuery = { __typename?: 'Query', defaultRates?: { __typename?: 'DefaultRate', defaultPerKmRate: number, ndiaPriceGuideTravelRate: number } | null };


  @Injectable({
    providedIn: 'root'
  })
  export class GetDefaultRatesQueryService extends Apollo.Query<GetDefaultRatesQuery, GetDefaultRatesQueryVariables> {
    document = Operations.GetDefaultRatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }